// File: frontend/src/components/form/Checkbox/Checkbox.js

import React from 'react';
import PropTypes from 'prop-types';
import { useLanguage } from '../../../contexts/LanguageContext';
import styles from './Checkbox.module.css';

const Checkbox = ({
  id,
  labelKey,
  checked,
  onChange,
  disabled = false,
  indeterminate = false,
  error = false,
  errorKey,
  required = false,
  darkTheme = false, // Add a darkTheme prop with default false
}) => {
  const { t } = useLanguage();

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  // Determine which theme-specific classes to use
  const wrapperClass = darkTheme 
    ? `${styles.checkboxWrapper} ${styles.darkTheme} ${error ? styles.hasError : ''}` 
    : `${styles.checkboxWrapper} ${error ? styles.hasError : ''}`;

  return (
    <div className={wrapperClass}>
      <input
        type="checkbox"
        id={id}
        className={styles.checkboxInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        ref={(input) => {
          if (input) {
            input.indeterminate = indeterminate;
          }
        }}
        required={required}
      />
      <label htmlFor={id} className={styles.checkboxLabel}>
        <span dangerouslySetInnerHTML={{ __html: t(labelKey) }} />
      </label>
      {error && errorKey && (
        <div className={styles.errorMessage}>{t(errorKey)}</div>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  error: PropTypes.bool,
  errorKey: PropTypes.string,
  required: PropTypes.bool,
  darkTheme: PropTypes.bool, // Add this to PropTypes
};

export default Checkbox;